/**
 * Capitaliza nombre/apellidos para mostrar en UI.
 * "juan hernandez uceta" → "Juan Hernandez Uceta"
 * "maría-josé" → "María-José"
 */
export function formatPersonName(value: string | null | undefined): string {
  if (!value) return '';
  return value
    .trim()
    .split(/\s+/)
    .filter(Boolean)
    .map((word) =>
      word
        .split('-')
        .map((part) => {
          if (!part) return '';
          const lower = part.toLocaleLowerCase('es');
          return lower.charAt(0).toLocaleUpperCase('es') + lower.slice(1);
        })
        .join('-'),
    )
    .join(' ');
}

/** Une nombre + apellidos ya capitalizados. */
export function formatFullName(
  first?: string | null,
  last?: string | null,
): string {
  return [formatPersonName(first), formatPersonName(last)]
    .filter(Boolean)
    .join(' ');
}
